/**
 * Entity Integration Syncing Status DTO enum - wire format for entity-level integration status
 * Represents the sync status of a specific entity type within an integration
 */
export enum IntegrationSyncingStatusDto {
  SYNCING = 'SYNCING',
  IDLE = 'IDLE',
}

/**
 * Type alias for request - makes intent clear
 */
export type IntegrationSyncingStatusRequest = IntegrationSyncingStatusDto;

/**
 * Type alias for response - makes intent clear
 */
export type IntegrationSyncingStatusResponse = IntegrationSyncingStatusDto;
